<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>档口助手操作日志</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form ref="form" :model="form" label-width="85px">
                <el-row :gutter="10">
                  <el-col>
                    <el-form-item label="输入搜索：">
                      <el-col :span="2">
                        <el-input
                          v-model="form.market_name"
                          placeholder="市场"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="2">
                        <el-input
                          v-model="form.supply_name"
                          placeholder="商家名称"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="2">
                        <el-input
                          v-model="form.goods_no"
                          placeholder="商品货号"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="3">
                        <el-input
                          v-model="form.goods_kh"
                          placeholder="商品款号"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="2">
                        <el-input
                          v-model="form.pgname"
                          placeholder="代采组"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="3">
                        <el-input
                          v-model="form.pg_name"
                          placeholder="买手组"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>

                      <el-col :span="3">
                        <el-select
                          v-if="resData"
                          v-model="form.log_type"
                          placeholder="操作日志类型"
                        >
                          <el-option label="全部" value=""></el-option>
                          <el-option
                            v-for="item in resData.logType"
                            :key="item.key"
                            :label="item.label"
                            :value="item.key"
                          ></el-option>
                        </el-select>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="7">
                    <el-form-item label="生成时间：">
                      <el-date-picker
                        v-model="form.create_time"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="2">
                    <el-button type="primary" @click="search">查询</el-button>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              prop="goods_img"
              label="商品图片"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    style="width: 100%; height: 100%"
                    :src="scope.row.goods_img"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="goods_no"
              label="商品货号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_kh"
              label="商品款号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="co_si"
              label="颜色/尺寸"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="price"
              label="代采价"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="market_name"
              label="市场"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pg_name"
              label="买手组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supplier_log_type"
              label="操作类型"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="schedule_day"
              label="排单天数"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="操作人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="操作时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: null,
      form: {
        status: "",
        referer: 1,
      },
      loading: false, // 加载动画是否显示
      url: "/erp/Supply/getMiniSupplyLog",
      status: "",
      curPage: 1,
      loading: false,
      tableLoading: false,
      filterFold: false,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  // created() {
  //   this.fetchData();
  // },
  methods: {
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 15);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
      return [start, end];
    },
    handleClick(row) {},
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.loading = true;
      this.$http.post(this.url, this.form).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          (this.status = this.filteredForm.status), (this.curPage = 1);
        }
      });
    },
    selectStatus(key) {
      this.form.status = this.status = key;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.demo-form-inline .el-form-item {
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/SupplyLog.vue